export function pad(n: string, width: number, z?: string) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

export const shrinkTextBased = (limit = 0, text = '') => {
  return text.length > limit ? `${text.substring(0, limit)}...` : text;
};

export const handleFiles = async (e: React.ChangeEvent<HTMLInputElement>, files: any, types?: Array<string>, size?: number) => {
  if (!e.target.files) {
    return { message: 'Please Upload File', success: false };
  }
  const getFile = e.target.files[0];
  const customSize = size ? size : 5000000;

  // File Size Check
  if (getFile.size > customSize) {
    return { message: 'File is larger than 5MB', success: false };
  }

  if (types) {
    const getMatch: Array<string> = types?.filter((items) => {
      return items === getFile.type;
    });
    if (getMatch.length === 0) {
      return {
        message: `Only the ${types.map((items) => {
          return `${items} `;
        })} formats are accepted`,
        success: false,
      };
    }
  }

  return { success: true, data: e.target.files[0] };
};

export const toBase64: (file: any) => Promise<unknown> = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

export const getFirstLetters = (str: string) => {
  const words = str.split(' ');
  let firstLetters;
  if (words.length === 1) {
    firstLetters = words.map((word) => word.slice(0, 1));
  } else {
    firstLetters = words.slice(0, 2).map((word) => word.slice(0, 1));
  }
  return firstLetters.join('');
};

export const handlesessionStorage: () => void = () => {
  sessionStorage.removeItem('step');
  sessionStorage.removeItem('formId');
};
